/**
 * Validates event.origin for messages assumed to come from ACV App (parent iframe host).
 */
export function isValidAcvParentMessageOrigin(origin: string): boolean {
  if (!origin || typeof origin !== 'string') return false;
  // Local ACV routinely embeds the production iframe. Allow localhost even in
  // production builds so acv-layout-info SET is not dropped.
  if (origin.includes('localhost') || origin.includes('127.0.0.1')) {
    return true;
  }
  try {
    const host = new URL(origin).hostname;
    if (host === 'acv.app' || host.endsWith('.acv.app')) return true;
    if (host.endsWith('.azurewebsites.net')) return true;
  } catch {
    if (origin.startsWith('https://portal.acv.app')) return true;
    if (origin.startsWith('https://portalnns.acv.app')) return true;
    if (origin.endsWith('.azurewebsites.net')) return true;
  }
  const configured = (import.meta.env?.VITE_ACV_PARENT_APP as string | undefined) || '';
  const allowed = configured
    .split(',')
    .map(o => o.trim())
    .filter(Boolean);
  return allowed.some(o => origin === o || origin.startsWith(o));
}
